import { useState } from 'react';
import { useEffect, useRef } from "react";
import AxiosInstance from '../../../Helper/AxiosInstance';
import { showDate } from '../../../Helper/Functions';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import { C, fOutfit, fBody } from '../../../Shared/Brand';
import { PageHeader, StatRow, StatCard, TableWrap } from '../../../Shared/DashboardUI';

function Dashboard() {
    const containerRef = useRef(null);
    const containernews = useRef(null);
    const [data, setData] = useState({})
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            symbols: [
                { proName: "FOREXCOM:SPXUSD", title: "S&P 500 Index" },
                { proName: "FOREXCOM:NSXUSD", title: "US 100 Cash CFD" },
                { proName: "FX_IDC:EURUSD", title: "EUR to USD" },
                { proName: "BITSTAMP:BTCUSD", title: "Bitcoin" },
                { proName: "BITSTAMP:ETHUSD", title: "Ethereum" }
            ],
            showSymbolLogo: true,
            isTransparent: true,
            displayMode: "adaptive",
            colorTheme: "dark",
            locale: "en"
        });

        if (containerRef.current) {
            containerRef.current.appendChild(script);
        }
        return () => {
            if (containerRef.current) {
                containerRef.current.innerHTML = "";
            }
        };
    }, []);
    useEffect(() => {
        let isAppended = false;

        if (containernews.current && !isAppended) {
            const script = document.createElement("script");
            script.src = "https://s3.tradingview.com/external-embedding/embed-widget-timeline.js";
            script.type = "text/javascript";
            script.async = true;
            script.innerHTML = JSON.stringify({
                showSymbolLogo: false,
                isTransparent: true,
                displayMode: "adaptive",
                market: "crypto",
                colorTheme: "dark",
                locale: "en",

            });

            containernews.current.appendChild(script);
            isAppended = true;
        }

        return () => {
            if (containernews.current) {
                containernews.current.innerHTML = "";
            }
        };
    }, []);
    const fetchData = async () => {
        try {
            const response = await AxiosInstance.get('/dashboard')
            if (response.status === 1) { setData(response.data) }
        } catch (err) { }
    }
    useEffect(() => { fetchData() }, [])
    return (
        <>
            <PageHeader title="Welcome Back" />

            <div className="xdb-card" style={{ marginBottom: '16px', background: `linear-gradient(135deg, rgba(247,147,26,0.10), ${C.card})` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <img alt="" src="/assets/images/social/ava_1.png" width="40" height="40" style={{ borderRadius: '50%' }} />
                    <div>
                        <div style={{ fontWeight: 700, color: C.ltx, fontFamily: fBody }}>Arbitrade Trading</div>
                        <div style={{ fontSize: '12px', color: C.ltx3 }}>
                            Last Login: {showDate(data?.lastlogin, 'd d m y')} {showDate(data?.lastlogin, 'h:m:sa')}
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '14px' }}>
                    <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '999px', padding: '6px 14px', fontSize: '12px', color: C.ltx2 }}>
                        User ID: <span style={{ color: C.ltx }}>{data?.regno}</span>
                    </div>
                    <div
                        style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '999px', padding: '6px 14px', fontSize: '12px', color: C.ltx2, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}
                        title="Copy referral link"
                        onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/signup/${data?.usdtaddress}`); toast.success("Code copied!", { toastId: 'referralId', position: 'top-center', autoClose: 700 }) }}
                    >
                        Referral Link: <span style={{ color: C.ltx }}>{window.location.origin}/signup/{data?.usdtaddress?.slice(0, 6)}....{data?.usdtaddress?.slice(-6)}</span>
                        <i className="ri-file-copy-line" style={{ color: C.primary }} />
                    </div>
                    {data?.parentid && (
                        <div style={{ background: 'rgba(255,255,255,0.04)', borderRadius: '999px', padding: '6px 14px', fontSize: '12px', color: C.ltx2 }}>
                            Parent: <span style={{ color: C.ltx }}>{data?.parentid}</span>
                        </div>
                    )}
                </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }} className="xdb-dashboard-grid">
                <div>
                    <StatRow>
                        <StatCard label="Trading Income" value="$0.00" icon="ri-robot-2-line" />
                        <StatCard label="Referral Bonus" value="$0.00" icon="ri-user-add-line" />
                        <StatCard label="Team Income" value={`$${Number(data?.rewardinc || 0).toFixed(2)}`} icon="ri-group-line" />
                        <StatCard label="Withdrawal Royalty" value={`$${Number(data?.rewardinc || 0).toFixed(2)}`} icon="ri-arrow-up-down-line" />
                    </StatRow>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }} className="xdb-dashboard-subgrid">
                        <div className="xdb-card">
                            <div style={{ textAlign: 'center', marginBottom: '14px' }}>
                                <div style={{ fontSize: '13px', color: C.ltx2 }}>Total Income</div>
                                <div style={{ fontSize: '24px', fontWeight: 700, color: C.ltx, fontFamily: fOutfit }}>${Number(data?.totalinc || 0).toFixed(2)}</div>
                            </div>
                            <TableWrap>
                                <tbody>
                                    <tr><td>Available Balance</td><td style={{ color: C.up, textAlign: 'right' }}>${Number(data?.balance || 0).toFixed(2)}</td></tr>
                                    <tr><td>Withdrawals</td><td style={{ color: C.down, textAlign: 'right' }}>${Number(data?.withdraw || 0).toFixed(2)}</td></tr>
                                </tbody>
                            </TableWrap>
                        </div>

                        <div className="xdb-card">
                            <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody }}>Team Details</h5>
                            <TableWrap>
                                <thead>
                                    <tr><th>#</th><th>Today</th><th>Total</th></tr>
                                </thead>
                                <tbody>
                                    <tr><td>Active Direct Team</td><td style={{ color: C.up }}>0.00</td><td>0.00</td></tr>
                                    <tr><td>Active Total Team</td><td style={{ color: C.up }}>0.00</td><td>0.00</td></tr>
                                    <tr><td>Team Investment</td><td style={{ color: C.up }}>0.00</td><td>0.00</td></tr>
                                    <tr><td>Referral Income</td><td style={{ color: C.up }}>0.00</td><td>0.00</td></tr>
                                    <tr><td>Team Income</td><td style={{ color: C.up }}>0.00</td><td>0.00</td></tr>
                                </tbody>
                            </TableWrap>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="xdb-card" style={{ marginBottom: '14px', background: 'rgba(247,147,26,0.1)', border: '1px solid rgba(247,147,26,0.25)' }}>
                        <h6 style={{ color: C.ltx, fontWeight: 700, margin: '0 0 10px', fontFamily: fBody }}>Participate in Our Free Airdrop and Get Exclusive Rewards Instantly.</h6>
                        <Link className="xdb-btn" to="/user/airdrop" style={{ textDecoration: 'none', display: 'inline-block' }}>Air Drop — $0.00</Link>
                    </div>
                    <div className="xdb-card" style={{ maxHeight: '360px', overflow: 'auto' }}>
                        <div ref={containernews} style={{ fontFamily: fBody }}>
                            <div className="tradingview-widget-container__widget"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="xdb-card" style={{ marginTop: '16px' }}>
                <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '14px', fontFamily: fBody }}>Tier Breakdown</h5>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px', maxHeight: '320px', overflow: 'auto' }}>
                    {(data?.levelinclist && JSON.parse(data?.levelinclist) || []).map((lv, idx) => (
                        <div key={idx} className="xdb-card" style={{ padding: '12px' }}>
                            <div style={{ fontSize: '12px', fontWeight: 700, color: C.primary, marginBottom: '8px' }}>
                                Tier {Number(lv.levelNo || 0).toString().padStart(2, '0')}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', marginBottom: '4px' }}>
                                <span style={{ color: C.ltx3 }}>Team</span>
                                <span style={{ color: C.ltx2, fontWeight: 600 }}>{Number(lv.totalCount || 0).toString().padStart(2, '0')}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                                <span style={{ color: C.ltx3 }}>Income</span>
                                <span style={{ color: C.ltx2 }}>${Number(lv.totalIncome || 0).toFixed(2)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="xdb-card" style={{ marginTop: '16px' }}>
                <div ref={containerRef}></div>
            </div>
        </>
    )
}

export default Dashboard
